import { defineMessages } from 'react-intl';

export const NEXT_AVAILABILITY_KEY = '@@nextAvailability';

export const LOCALIZED_STRINGS = defineMessages({
    NextAvailabilityIs: {
        id: 'Profile.Components.NextAvailability.NextAvailabilityIs',
        defaultMessage: 'next availability is {time}',
    },
});
